<template>
  <div>
    <el-row>
      <el-col :span="24">
        <img class="banner" src="@/assets/images/aboutus.png" alt=""
      /></el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="16" :md="14">
        <div class="txt1">
          <h1>企业简介</h1>
          <img src="@/assets/images/ge.png" alt="" />
          <p>
            苏州飞康生物医药有限公司成立于2014年，总部位于苏州市太仓生物港，研发基地位于上海市复旦大学创业园区。
          </p>
          <p>
            公司集研发、生产和销售为一体，是一家致力于发展快速、准确和方便的智能健康设备和POCT体外诊断试剂的高技术企业。
          </p>
        </div></el-col
      >
    </el-row>

    <el-row class="txt3" type="flex" justify="center">
      <el-col :span="24">
        <div class="txt2">
          <h1>企业文化</h1>
          <img src="@/assets/images/ge.png" alt="" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="4">
        <div>
          <img class="img" src="@/assets/images/txt3.png" alt="" />
          <h2>愿景</h2>
          <p>让每个家庭都享受科技所带来的</p>
          <p>健康、便捷和快乐的生活</p>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="4">
        <div>
          <img class="img" src="@/assets/images/txt1.png" alt="" />
          <h2>价值观</h2>
          <p>创新与行动</p>
          <p>改变世界</p>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="4">
        <div>
          <img class="img" src="@/assets/images/txt2.png" alt="" />
          <h2>使命</h2>
          <p>让每个人都能随时随地检测</p>
          <p>自己的健康状态</p>
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <div class="txt2">
          <h1>企业历程</h1>
          <img src="@/assets/images/ge.png" alt="" />
        </div>
      </el-col>
      <el-col :xs="22" :sm="15" :md="11">
        <div class="block">
          <el-timeline>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2014</h3>
                <p>
                  王博士在太仓创办了苏州飞康生物医药有限公司，致力于自主体外诊断产品的开发及其在家庭中的应用。
                </p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2015</h3>
                <p>
                  公司研发出肝癌新型诊断试剂盒、孕妇早产诊断试剂盒、孕妇胎膜早破诊断试剂盒。
                </p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2016</h3>
                <p>
                  公司推出AMH检测（抗苗勒氏管激素）采样试剂盒与婴幼儿智能体温贴，针对女性卵巢储备检测、婴幼儿测温场景痛点，提供便捷高效的检测监测解决方案。
                </p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2017</h3>
                <p>公司完成数百万元的pre-A轮的融资。</p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2018</h3>
                <p>
                  公司研发出度芽1和度芽2智能体温贴,可以实现24小时持续远程监测幼儿体温,高低温报警和智能体温曲线记录。
                </p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2019</h3>
                <p>AMH指尖血检测全面推向市场。</p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2020</h3>
                <p>
                  “一滴血检测卵巢功能”（一滴指尖血同时测定AMH、FSH和LH）服务进入辅助生殖、医美等行业，造福广大女性群体。
                </p>
              </div>
            </el-timeline-item>
            <el-timeline-item color="rgb(75, 12, 119)">
              <div>
                <h3>2021</h3>
                <p>公司确定开发手机居家健康检测平台的战略方向。</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <div class="txt2">
          <h1>技术团队</h1>
          <img src="@/assets/images/ge.png" alt="" />
        </div>
      </el-col>
      <el-col :xs="22" :sm="10" :md="7">
        <div class="left">
          <div class="top">
            <img src="@/assets/images/wangbo.jpg" alt="" />
            <h2>王锋 博士</h2>
          </div>
          <el-card>
            <h3>首席执行官<br />擅长领域：单分子生物物理检测</h3>
            <p>● 清华大学学士、硕士</p>
            <p>● 哥伦比亚大学医学中心副研究员</p>
            <p>● 在《自然结构分子生物学》等顶尖杂志发表论文</p>
            <p>● 领导开发了多款应用于家庭的健康检测产品</p>
          </el-card>
        </div>
      </el-col>
      <el-col :xs="22" :sm="10" :md="7">
        <div class="right">
          <div class="top">
            <img src="@/assets/images/pic.jpg" alt="" />
            <h2>戴星灿 博士</h2>
          </div>
          <el-card>
            <h3>首席技术官<br />擅长领域：光学和算法</h3>
            <p>● 清华大学学士、硕士</p>
            <p>● 清华大学物理学系副教授</p>
            <p>● 美国加州大学伯克利分校博士</p>
            <p>
              ●
              主持和参与国家重大科学研究计划、中国自然科学基金重大研究计划和中国自然科学基金多个项目的研究
            </p>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <div class="txt2">
          <h1>公司发明专利</h1>
          <img src="@/assets/images/ge.png" alt="" />
        </div>
      </el-col>
      <el-col :xs="22" :sm="16" :md="14">
        <img class="gszz" src="@/assets/images/gszz.png" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Aboutus",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.el-row {
  flex-wrap: wrap;
}
.txt1 {
  text-align: center;
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
}
.txt2 {
  text-align: center;
  margin-top: 100px;
}
.txt3 {
  text-align: center;
  .img {
    margin-top: 10px;
    width: 90px;
    height: auto;
  }
}
.block {
  margin-top: 30px;
}
.left,
.right {
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
  h3 {
    margin-bottom: 15px;
  }
}
.top {
  text-align: center;
  img {
    border: 2px solid rgb(100, 16, 173);
    border-radius: 15px;
    width: 150px;
    height: 150px;
  }
}
.gszz {
  width: 100%;
}
</style>
